import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { axiosGet, axiosPatch, axiosPost } from 'Redux/axiosHelper'
import {
  LeagueDiscountPayload,
  LeagueDiscountResp,
} from 'types/league/leagueDiscount'

const getDiscountByLeagueId = async (leagueId: string) => {
  const response = await axiosGet(`v1/league-discount/league/${leagueId}`)
  return response.data
}

export const useGetDiscountByLeagueId = (leagueId: string) => {
  const leagueDiscountList = useQuery<LeagueDiscountResp[]>(
    ['get-discount-by-league-id'],
    () => getDiscountByLeagueId(leagueId),
    {
      enabled: false,
    },
  )
  return leagueDiscountList
}

//add discount code
const addDiscountCode = async ({
  leagueId,
  payload,
}: {
  leagueId: string
  payload: LeagueDiscountPayload
}) => {
  const response = await axiosPost(payload, `v1/league-discount/${leagueId}`)
  return response.data
}

export const useAddDiscountCodeToLeague = () => {
  const queryClient = useQueryClient()
  return useMutation(addDiscountCode, {
    onSuccess: newDiscountCode => {
      queryClient.setQueryData(
        ['get-discount-by-league-id'],
        (oldData: LeagueDiscountResp[] | undefined) => {
          if (!oldData) return [newDiscountCode]
          return [...oldData, newDiscountCode]
        },
      )
    },
  })
}

// update discount code
const updateDiscountCode = async ({
  discountCodeId,
  payload,
}: {
  discountCodeId: string
  payload: LeagueDiscountPayload
}) => {
  const response = await axiosPatch(
    payload,
    `v1/league-discount/${discountCodeId}`,
  )
  return response.data
}

export const useUpdateDiscountCode = () => {
  const queryClient = useQueryClient()
  return useMutation(updateDiscountCode, {
    onSuccess: updatedDiscount => {
      queryClient.setQueryData(
        ['get-discount-by-league-id'],
        (oldData: LeagueDiscountResp[] | undefined) => {
          if (!oldData) return undefined
          return oldData.map(discount =>
            discount._id === updatedDiscount._id ? updatedDiscount : discount,
          )
        },
      )
    },
  })
}

// change status of discount code
const changeDiscountStatus = async ({
  discountCodeId,
  payload,
}: {
  discountCodeId: string
  payload: {
    status: 'archived'
  }
}) => {
  const response = await axiosPatch(
    payload,
    `v1/league-discount/status/${discountCodeId}`,
  )
  return response.data
}

export const useChangeDiscountStatus = () => {
  const queryClient = useQueryClient()
  return useMutation(changeDiscountStatus, {
    onSuccess: updatedDiscount => {
      queryClient.setQueryData(
        ['get-discount-by-league-id'],
        (oldData: LeagueDiscountResp[] | undefined) => {
          if (!oldData) return undefined
          return oldData.filter(
            discount => discount._id !== updatedDiscount._id,
          )
        },
      )
    },
  })
}
